import React from "react";
import { Card, Container, Row, Col } from "react-bootstrap";

const Services = () => {
  const services = [
    {
      title: "Decommissioning and Planning Management",
      text: "From EPRD strategy to offshore execution, we manage the full lifecycle of decommissioning projects — ensuring safety, efficiency, and environmental responsibility.",
      imageUrl: "/image1.png", // replace with actual image paths
    },
    {
      title: "Subsea Engineering & Construction Support",
      text: "Expert design, procedure development, and offshore supervision for subsea tie-ins, cable installation, riser replacements, and infrastructure upgrades.",
      imageUrl: "path/to/image2.jpg",
    },
    {
      title: "Regulatory and Technical Compliance",
      text: "We ensure every operation meets UK HSE, Oil & Gas UK, and international offshore standards. From documentation to audits, we manage full compliance with confidence.",
      imageUrl: "path/to/image3.jpg",
    },
    {
      title: "Offshore Client Representation",
      text: "Acting as Senior Client Technical Representatives, we safeguard our clients’ interests offshore — ensuring contractors deliver to exacting safety, technical, and quality standards.",
      imageUrl: "path/to/image4.jpg",
    },
    {
      title: "Project Readiness and Quality Assurance",
      text: "We verify that all engineering, safety, and operational deliverables are complete before offshore mobilisation — reducing downtime and ensuring project readiness.",
      imageUrl: "path/to/image5.jpg",
    },
  ];

  return (
    <Container>
      <h2 className="title">Our Services</h2>
      <Row>
        {services.map((service, index) => (
          <Col key={index} md={4} className="mb-4">
            <Card>
              <Card.Img
                variant="top"
                src={service.imageUrl}
                alt={service.title}
              />
              <Card.Body>
                <Card.Title>{service.title}</Card.Title>
                <Card.Text>{service.text}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Services;
